import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogueHandler, DeleteUserDialogueHandler } from '../types';
import DeleteUserContext from './DeleteUserContext';

const { ConfirmationDialogue } = vp;

type DeleteUserDialogueProps = {
  handleDialogue: DialogueHandler<DeleteUserDialogueHandler>;
};

type FC = FunctionComponent<DeleteUserDialogueProps>;

const DeleteUserDialogue: FC = ({ handleDialogue }: DeleteUserDialogueProps) => {
  const { showDeleteUserSuccessAlert, showDeleteUserErrorAlert, showDeleteUserConfirmationAlert, DeleteUserError } =
    useContext(DeleteUserContext);
  const { t } = useTranslation('translations', { keyPrefix: 'Users.DeleteUser.DeleteUserDialogue' });
  return useMemo(
    () => (
      <div>
        {/* User Delete Confirmation */}
        <ConfirmationDialogue
          isVisible={showDeleteUserConfirmationAlert}
          title={t('confirmation.title')}
          status="alert"
          subTitle={t('confirmation.subTitle')}
          confirm={{
            label: t('confirmation.confirmLabel'),
            action: () => handleDialogue({ type: 'alertDelete', state: 'success' }),
          }}
          cancel={{
            label: t('confirmation.cancelLabel'),
            action: () => handleDialogue({ type: 'alertDelete', state: 'fail' }),
          }}
        />
        {/* Delete User Error */}
        <ConfirmationDialogue
          isVisible={showDeleteUserErrorAlert}
          title={t('error.title')}
          status="error"
          subTitle={t('error.subTitle', { DeleteUserError })}
          confirm={{
            label: t('error.confirmLabel'),
            action: () => handleDialogue({ type: 'delete', state: 'fail' }),
          }}
        />
        {/* Delete User Success */}
        <ConfirmationDialogue
          isVisible={showDeleteUserSuccessAlert}
          title={t('success.title')}
          status="success"
          subTitle={t('success.subTitle')}
          confirm={{
            label: t('success.confirmLabel'),
            action: () => handleDialogue({ type: 'delete', state: 'success' }),
          }}
        />
      </div>
    ),
    [showDeleteUserSuccessAlert, showDeleteUserErrorAlert, showDeleteUserConfirmationAlert],
  );
};

export default DeleteUserDialogue;
